import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
// import { userReducer } from "src/features/users/store/user.slice";

export const baseService = createApi({
  reducerPath: "baseService",
  baseQuery: fakeBaseQuery(),
  tagTypes: [
    "Admin",
    "Organization",
    "VoucherCode",
    "WithdrawalRequest",
    "CancellationRequest",
    "Booking",
    "AISession",
    "WordBank",
    "SubscriptionUser",
    "PrivateStudent",
    "PrivateTutor",
    "Tutor",
    "Student",
    "CoachApplication",
    "UserTransaction",
    "users",
    "promoters",
    "Post",
    "onboarding-reports",
    "users-reports",
    "function-errors",
    "AI_TOPICS",
    "AI_COACH_PROMPTS",
    "AI_COACH_LEVEL_VOCABULARIES",
    "AI_CUSTOM_SCENARIOS",
    "KarmaExchanges",
    "Rewards",
    "NotificationHealth",
    "Recruiter",
  ],
  endpoints: (builder) => ({}),
});

// const rootReducer=combineReducers({
//   [baseService.reducerPath]:baseService.reducer,
//   user:userReducer
// })

// export const store=configureStore({
//   reducer:rootReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({ serializableCheck: false }).concat(
//       baseService.middleware,
//     ),
// })

// type RootState=ReturnType<typeof store.getState>
// type AppDispatch=typeof store.dispatch

// export const useAppDispatch=useDispatch.withTypes<AppDispatch>()
// export const useAppSelector=useSelector.withTypes<RootState>()
